'use client';

import { isEmpty } from 'validator';
import { asText, Content } from '@prismicio/client';

// Contexts
import { useClinicFinderContext } from '@/context/ClinicFinderProvider';

// Components
import { CallToActionSearch } from '@/components/Controls/CallToActionSearch';

type SearchContainerProps = {
  slice: Content.ClinicHeadlineSliceWithClinicFinderHeadline;
};

export const SearchContainer = ({ slice }: SearchContainerProps) => {
  const { clinics, setFilteredClinics } = useClinicFinderContext();

  const { search_label, submit_label } = slice.primary;

  const onSubmit = (value: string) => {
    if (isEmpty(value)) {
      setFilteredClinics(clinics);

      return;
    }

    const formattedValue = value.toString().toLocaleLowerCase();

    const response = clinics.filter(({ address, clinicName }) => {
      const hasMatchingClinicName = clinicName
        .toLocaleLowerCase()
        .includes(formattedValue);

      if (hasMatchingClinicName) {
        return true;
      }

      const hasAddressMatch = address.some((addressLine) => {
        const formattedAddressLine = addressLine.toLocaleLowerCase();

        return formattedAddressLine.includes(formattedValue);
      });

      return hasAddressMatch;
    });

    setFilteredClinics(response);
  };

  return (
    <CallToActionSearch
      required={false}
      onSubmit={onSubmit}
      isProcessing={false}
      inputLabel={asText(search_label)}
      submitLabel={asText(submit_label)}
      id="clinic-finder-search-container"
      inputPlaceholder={asText(search_label)}
    />
  );
};
